import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import add from '@iconify/icons-ic/add';
import exportIcon from '@iconify/icons-ant-design/export-outline';
import { MdSystemUpdateAlt } from 'react-icons/md';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
// import export from '@iconify/icons-ic/export';
// material
import { styled } from '@mui/material/styles';
import {
  Box,
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  Grid,
  Select,
  MenuItem
} from '@mui/material';
import { navigate } from '@storybook/addon-links';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { BiCloudDownload } from 'react-icons/bi';
import useGlobalSelector from '../../../store/Slice/Global/GlobalSelector';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 45,
  display: 'flex',
  justifyContent: 'space-between'
  // padding: '0 !important'
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  paddingTop: 2,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

export default function UserListToolbar({
  numSelected,
  filterName,
  onFilterName,
  parent,
  filterState,
  setFilterState,
  setFilterDatesRange,
  setFilterName,
  typeIdValue,
  handleExport
}) {
  const [isOpenFilter, openFilter] = useState(false);
  const { CityDrop, LoanTypeDrop, StatusDrop, SourceDrop, AccessLevelList, DepartmentListDrop } =
    useGlobalSelector();

  // console.log('DepartmentListDrop in toolbar', DepartmentListDrop);
  const navigate = useNavigate();
  const handleRemoveFilter = (e) => {
    if (typeof setFilterDatesRange === 'function') {
      setFilterDatesRange([
        {
          startDate: null,
          endDate: null,
          key: 'selection'
        }
      ]);
    }

    if (typeof setFilterState === 'function') {
      setFilterState({
        ...filterState,
        product: '',
        productId: null,
        city: null,
        cityId: null,
        isActive: '',
        employmentType: '',
        statusId: null,
        departmentId: null,
        branchId: null,
        accessLevelId: null
      });
    }

    if (typeof setFilterName === 'function') {
      setFilterName('');
    }
  };

  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={3}>
            <Grid item xs>
              <Select
                fullWidth
                value={filterState.departmentId ?? ' '}
                onChange={(e) =>
                  setFilterState({
                    ...filterState,
                    departmentId: e.target.value === ' ' ? null : e.target.value
                  })
                }
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterState.departmentId}`
                }}
              >
                <MenuItem value=" ">Select Departement</MenuItem>
                {Array.isArray(DepartmentListDrop)
                  ? DepartmentListDrop.map((opt) => (
                      <MenuItem key={opt?.value ?? opt?.id} value={opt?.value ?? opt?.id}>
                        {opt?.label ?? opt?.label ?? opt?.label ?? opt?.value}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </Grid>

            {/* Access Level */}
            <Grid item xs>
              <Select
                fullWidth
                value={filterState.accessLevelId ?? ' '}
                onChange={(e) =>
                  setFilterState({
                    ...filterState,
                    accessLevelId: e.target.value === ' ' ? null : e.target.value
                  })
                }
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterState.accessLevelId}`
                }}
              >
                <MenuItem value=" ">Select Access Level</MenuItem>
                {Array.isArray(AccessLevelList)
                  ? AccessLevelList.map((opt) => (
                      <MenuItem
                        key={opt?.accessLevelId ?? opt?.id}
                        value={opt?.accessLevelId ?? opt?.id}
                      >
                        {opt?.accessLevelName ?? opt?.name ?? opt?.label ?? opt?.value}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </Grid>

            <Grid item xs>
              <Select
                fullWidth
                displayEmpty
                value={filterState.isActive ?? ''}
                onChange={(e) =>
                  setFilterState({
                    ...filterState,
                    isActive: e.target.value === '' ? null : e.target.value
                  })
                }
                inputProps={{
                  className: 'textInput customSelectBox'
                }}
              >
                <MenuItem value="" disabled>
                  Select Status
                </MenuItem>

                <MenuItem value="true">Active</MenuItem>
                <MenuItem value="false">Inactive</MenuItem>
              </Select>
            </Grid>

            <Grid item xs="auto">
              <Tooltip title="Reset Filter">
                <IconButton
                  sx={{ padding: '0', paddingTop: '0.4rem', paddingBottom: '0.4rem' }}
                  onClick={(e) => {
                    handleRemoveFilter(e);
                  }}
                >
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}
      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1'
        }}
      >
        <Box>
          {typeIdValue === 304 && (
            <Tooltip title="Add New" placement="top" arrow>
              <IconButton className="squareIconButton" onClick={(e) => navigate(`/${parent}/add`)}>
                <Icon icon={add} width={18} />
              </IconButton>
            </Tooltip>
          )}
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Download" placement="top" arrow>
            <IconButton className="squareIconButton" onClick={(e) => handleExport(typeIdValue)}>
              <BiCloudDownload size={18} />
            </IconButton>
          </Tooltip>
        </Box>

        <Box />
        <Box>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Users"
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Filter list">
            <IconButton
              onClick={(e) => {
                if (isOpenFilter) {
                  openFilter(false);
                } else {
                  openFilter(true);
                }
              }}
            >
              <Icon icon={roundFilterList} />
            </IconButton>
          </Tooltip>
        </Box>
      </RootStyle>
    </>
  );
}
